/**
 * Constants for Unico Create Process retry logic
 */

export const MAX_RETRY_ATTEMPTS = 3;

export const RETRY_DELAY_MS = 2000;

export const UNICO_UNAVAILABLE_MESSAGE =
  "Não é possível acessar a plataforma de captura de biometria no momento.";

export const UNICO_ERROR_MESSAGES: Record<number, string> = {
  400: "Erro na requisição. Verifique os dados enviados.",
  403: "Erro de permissão. Verifique suas credenciais.",
  404: "Recurso não encontrado.",
  500: "Erro interno do servidor. Tente novamente mais tarde."
};
